// TOP LEVEL IMPORTS
import gql from 'graphql-tag';

export default gql`
  query QuestionnairesByClientId($_id: ID!) {
    questionnairesByClientId(_id: $_id) {
      _id
      title
      questions
      complete
      sentAt
      results {
        question
        answer
      }
      completedAt
      organization {
        title
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/ApolloClient/Queries/questionnairesByClientId.js